'use strict';

intellidealerAppCoreModule.factory('publicResource', function ($resource, appConfigurationService) {
  return {
    version: $resource(appConfigurationService.basePath + '/rest/public/version')
  };
});
